import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import './MobileHeader.css';

const MobileHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="mobile-header">
        <Link to="/" className="mobile-header-logo">
          <img src="/MDA_Logo.svg" alt="Maarten Delen Advies" />
        </Link>

        <button
          className={`hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Overlay */}
      {isMenuOpen && <div className="mobile-menu-overlay" onClick={closeMenu}></div>}

      {/* Mobile Menu */}
      <nav className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <img src="/MDA_Logo.svg" alt="Maarten Delen Advies" className="mobile-menu-logo" />
          <button className="mobile-menu-close" onClick={closeMenu}>
            ×
          </button>
        </div>

        <div className="mobile-menu-items">
          <NavLink to="/" className="mobile-menu-item" onClick={closeMenu}>
            Home
          </NavLink>
          <NavLink to="/CV" className="mobile-menu-item" onClick={closeMenu}>
            CV
          </NavLink>
          <NavLink to="/about" className="mobile-menu-item" onClick={closeMenu}>
            Over Maarten
          </NavLink>
          <NavLink to="/contact" className="mobile-menu-item" onClick={closeMenu}>
            Contact
          </NavLink>
          <NavLink to="/stories" className="mobile-menu-item" onClick={closeMenu}>
            Ultra Korte Verhalen
          </NavLink>
          {isAuthenticated && (
            <NavLink to="/admin" className="mobile-menu-item" onClick={closeMenu}>
              Admin
            </NavLink>
          )}
        </div>
      </nav>
    </>
  );
};

export default MobileHeader;